<template>
  <div :class="[{check:isCheck}, 'input_check_box']" @click="inputCheckFn">

  </div>
</template>

<script>
export default {
  props: {
    isCheck: {
      default: false,
      required: false
    }
  },
  methods: {
    inputCheckFn: function() {
      let isCheck = !this.isCheck
      this.$emit('checkFn', isCheck)
    }
  }
}
</script>

<style lang='less'>
.input_check_box {
  width: 18px;
  height: 18px;
  background: url('~@img/checbox.png') 0 -18px no-repeat;
  &.check {
    background-position: 0 0;
  }
}
</style>



// WEBPACK FOOTER //
// input_check_box.vue?2d7c0abe